import { ScopedBusinessEntity, type IMarketingCloudUser } from '@ads/iam-library';

/**
 * Resolves the advertiser ID to pass into content-studio context.
 * Prefers the marketplace navbar selection (ScopedBusinessEntity),
 * otherwise falls back to the user's sole business entity when unambiguous.
 */
export function resolveContentStudioAdvertiserId(
  user?: IMarketingCloudUser | null,
): string | undefined {
  const scopedBusinessEntity = new ScopedBusinessEntity();
  const fromScope = scopedBusinessEntity.getId();
  if (fromScope) return fromScope;

  const ids = user?.getBusinessEntityIds();
  if (ids?.length === 1) return ids[0].toString();

  return undefined;
}
